import { useState, useRef, useEffect } from 'react'
import ButlerChat from './ButlerChat'
import ButlerButton from './ButlerButton'

interface Props {
  shortcode: string
  botName: string
  avatarUrl?: string
  welcomeMessage: string
  position: 'bottom-right' | 'bottom-left'
}

export default function ButlerWidget({ shortcode, botName, avatarUrl, welcomeMessage, position }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  const posClass = position === 'bottom-left' ? 'left-5' : 'right-5'

  return (
    <>
      {isOpen && (
        <div className={`fixed bottom-24 ${posClass} z-50 w-[380px] max-w-[calc(100vw-40px)] h-[550px] max-h-[70vh]`}>
          <ButlerChat
            shortcode={shortcode}
            botName={botName}
            avatarUrl={avatarUrl}
            welcomeMessage={welcomeMessage}
            onClose={() => setIsOpen(false)}
          />
        </div>
      )}
      <div className={`fixed bottom-5 ${posClass} z-50`}>
        <ButlerButton
          avatarUrl={avatarUrl}
          onClick={() => setIsOpen(!isOpen)}
          isOpen={isOpen}
        />
      </div>
    </>
  )
}
